export default "/react/people-dba8e754.svg";